import React from 'react';
import { Space } from 'antd';
import { I18n } from '@aws-amplify/core';

import { BaseModal } from './shared/BaseModal';
import { PrimaryButton } from '@/components/ui/Button';
import type { ModalWithNameProps } from './shared/types';
import * as Typography from '@/components/Settings/DataExtraction/styles';
import * as S from './styles';

export function ErrorModal({ visible, onCancel, extractionName }: Readonly<ModalWithNameProps>) {
	return (
		<BaseModal visible={visible} onCancel={onCancel} footer={false}>
			<Space direction="vertical" size={24} align="center" style={{ width: '100%' }}>
				<S.ErrorIcon />
				<Typography.LabelMediumRegular>
					{`${I18n.get('Could not create extraction')} "${extractionName}", ${I18n.get('please try again')}.`}
				</Typography.LabelMediumRegular>
				<PrimaryButton type="primary" onClick={onCancel}>
					{I18n.get('Close')}
				</PrimaryButton>
			</Space>
		</BaseModal>
	);
}
